<div class="dialog">
    <div fxLayout="column" fxLayoutAlign="center center">
        <img alt="Error" src="../../../../assets/images/gif-2.gif" width="252px" fxFlexAlign="center">
        <p class=" txtCenter" style="color:rgb(241, 49, 15); margin:5px 0px;line-height:20px;">{{Result}} !</p>
    </div>
</div>